import { DesktopTabs } from './DesktopTabs';
import { SidebarTabs } from './SidebarTabs';

export const Tabs = ({ sidebar = false }) => {
  if (!sidebar) {
    return <DesktopTabs />;
  } else {
    return <SidebarTabs />;
  }
};
